// @flow
import React from 'react'

import DateInputs from './DateInputs'

// core
import moment from '../../Moment'

// types
import type { DefaultFormFieldState, DefaultFormFieldType } from './AbstractFormField'

type DateTimeInputsProps = DefaultFormFieldType & {
  domain: {
    _type: string,
    pattern?: string,
    minDate?: string,
    maxDate?: string
  },
  hideButton?: boolean,
  value?: Date,
  doNotRenderDatePicker?: boolean,
  endOfDay?: boolean,
}

type DateTimeInputsState = DefaultFormFieldState & {
  editCompleted: boolean,
  pickerOpened: boolean,
  day: string,
  month: string,
  year: string,
}

export default class DateTimeInputs extends DateInputs<DateTimeInputsProps, DateTimeInputsState> {

  setLocalInputsFromValue = (props: DateTimeInputsProps) => {
    if (props.value) {
      const date = moment(props.value, props.value.length === 6 ? ['YYYY-MM-DD', 'DD.MM.YYYY'] : 'YYYY-MM-DDTHH:mm')
      if (date.isValid()) {
        this.setState({
          day: date.format('DD'),
          month: date.format('MM'),
          year: date.format('YYYY'),
        })
      }
    } else {
      this.setState({
        day: '',
        month: '',
        year: '',
      })
    }
  }

  handleOnChange = (datetime: string | Object) => {
    if (!datetime || typeof datetime === 'string') {
      this.setState({ value: '', pickerOpened: false, day: '', month: '', year: '' })
    } else {
      this.setState({ value: datetime, pickerOpened: false })
    }
  }

  handleOnBlur = (datetime: string | Object) => {
    if (!datetime || typeof datetime === 'string') {
      this.props.onChange('')
    } else {
      this.setState({ value: datetime, pickerOpened: false, pristine: false })
      if (this.props.endOfDay) {
        this.props.onChange(datetime.endOf('day').format('YYYY-MM-DDTHH:mm'))
      } else if (datetime.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
        this.props.onChange(datetime.endOf('day').add(-30, 'minutes').format('YYYY-MM-DDTHH:mm'))
      } else {
        this.props.onChange(datetime.startOf('day').format('YYYY-MM-DDTHH:mm'))
      }
    }
  }
}
